import { eventQBus } from '@otto-ec/global-resources/event-q-bus';

/**
 *
 */
class FirebaseTracking {
    trackFirebase(articleNumber) {
        if (window.o_apps?.runningInApp?.() && articleNumber) {
            eventQBus.emit('ft-apps.firebase.eventTracking', {
                event_name: 'add_to_wishlist',
                event_params: { item_id: articleNumber, quantity: 1 }
            });
        }
    }
}

export { FirebaseTracking };
